(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["adamu-ai-summary"] && !Shopify.designMode) return;
  try {
    
(function() {

  // --- Expand/collapse summary text (mobile) ---
  var summaryBtn = document.querySelector('.adamu-ai-summary__expand');
  var summaryText = document.getElementById('ai-summary-text');
  if (summaryBtn && summaryText) {
    summaryBtn.addEventListener('click', function() {
      var expanded = summaryBtn.getAttribute('aria-expanded') === 'true';
      summaryBtn.setAttribute('aria-expanded', String(!expanded));
      summaryText.classList.toggle('is-expanded', !expanded);
    });
  }

  // --- Ingredient table: show/hide toggle ---
  // Rows 4+ are hidden via CSS class set in Liquid.
  // JS only needs to: reveal the button if hidden rows exist, and wire the click.
  var tableBody = document.querySelector('[data-table-body]');
  var toggleBtn = document.querySelector('[data-table-toggle]');
  var VISIBLE_COUNT = 3;

  if (tableBody && toggleBtn) {
    var hiddenRows = tableBody.querySelectorAll('.adamu-ntable__row--hidden');

    if (hiddenRows.length > 0) {
      // Show the toggle button
      toggleBtn.style.display = '';

      toggleBtn.addEventListener('click', function() {
        var expanded = toggleBtn.getAttribute('aria-expanded') === 'true';

        hiddenRows.forEach(function(row) {
          row.classList.toggle('adamu-ntable__row--hidden', expanded);
        });

        toggleBtn.setAttribute('aria-expanded', String(!expanded));
      });
    }
  }

  // --- Row scroll animations via IntersectionObserver ---
  var allRows = document.querySelectorAll('.adamu-ntable__row');
  if (!allRows.length) return;

  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });

    allRows.forEach(function(row) { observer.observe(row); });
  } else {
    allRows.forEach(function(row) { row.classList.add('is-visible'); });
  }

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ayuba-faq"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  function initFAQ(sectionEl) {
    var items = sectionEl.querySelectorAll('.ayuba-faq__item');

    items.forEach(function (item) {
      var btn    = item.querySelector('.ayuba-faq__question');
      var answer = item.querySelector('.ayuba-faq__answer');

      if (!btn || !answer) return;

      btn.addEventListener('click', function () {
        var isOpen = item.classList.contains('is-open');

        // Close all
        items.forEach(function (other) {
          var otherBtn    = other.querySelector('.ayuba-faq__question');
          var otherAnswer = other.querySelector('.ayuba-faq__answer');
          if (!otherBtn || !otherAnswer) return;

          other.classList.remove('is-open');
          otherBtn.setAttribute('aria-expanded', 'false');
          otherAnswer.classList.remove('is-visible');
        });

        // Open clicked (if it was closed)
        if (!isOpen) {
          item.classList.add('is-open');
          btn.setAttribute('aria-expanded', 'true');
          answer.classList.add('is-visible');
        }
      });
    });
  }

  // Horizon section:load event
  document.addEventListener('DOMContentLoaded', function () {
    var sections = document.querySelectorAll('[data-section-type="ayuba-faq"]');
    sections.forEach(initFAQ);
  });

  // Theme editor live reload
  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('[data-section-type="ayuba-faq"]');
    if (section) initFAQ(section);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
